export const DefaultPlus: React.FC<React.SVGProps<SVGSVGElement>> = props => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M12 5V19M5 12H19" stroke="#1A1A1A" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
